import React, { type FunctionComponent } from 'react'
import { locationHasInvalidCoordinates } from '../locationHelpers'

type Props = {
  locations: ExternalLocationType[]
}

export const ExternalLocationsInvalidCoordinatesWarning: FunctionComponent<Props> = ({ locations }) => {
  const locationsWithInvalidCoordinates = locations.filter(locationHasInvalidCoordinates)
  const numLocationsWithInvalidCoordinates = locationsWithInvalidCoordinates.length
  const locationMsg = numLocationsWithInvalidCoordinates === 1 ? 'location is' : 'locations are'

  return numLocationsWithInvalidCoordinates > 0 ? (
    <div className="group absolute top-2 w-[80%] left-1/2 -translate-x-1/2 p-4 border-2 border-amber-400 rounded-lg font-bold bg-[rgba(255,255,255,0.9)] z-[2] flex items-center justify-center cursor-pointer">
      <span className="icon-[fluent--location-24-regular] size-6" />
      <div className="ml-2">
        {numLocationsWithInvalidCoordinates} {locationMsg} not displayed on the map due to invalid/missing coordinates.
      </div>
      <div className="absolute top-[3.5rem] left-0 w-full py-2 px-4 text-white rounded-lg bg-[rgba(0,0,0,0.8)] transform translate-y-[20%] opacity-0 text-left pointer-events-none transition group-hover:translate-y-[0] group-hover:opacity-100">
        {locationsWithInvalidCoordinates.map(location => (
          <span key={`error-${location.name}`} className="block">
            {location.name}
          </span>
        ))}
      </div>
    </div>
  ) : null
}
